namespace GeniuzPOS.ReportMasterData {
    export interface Report_1406Row {
        Id?: string;
        DocDate?: string;
        SubCat2Code?: string;
        SubCat2Name?: string;
        Qty?: number;
        GrossSales?: number;
        NetSales?: number;
        AllItemDiscount?: number;
        NetSalesExVat?: number;
        VatOfNetSales?: number;
    }

    export namespace Report_1406Row {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'ReportMasterData.Report_1406';
        export const deletePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:ยอดขายรวมร้านค้า:View';
        export const insertPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:ยอดขายรวมร้านค้า:View';
        export const readPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:ยอดขายรวมร้านค้า:View';
        export const updatePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:ยอดขายรวมร้านค้า:View';

        export declare const enum Fields {
            Id = "Id",
            DocDate = "DocDate",
            SubCat2Code = "SubCat2Code",
            SubCat2Name = "SubCat2Name",
            Qty = "Qty",
            GrossSales = "GrossSales",
            NetSales = "NetSales",
            AllItemDiscount = "AllItemDiscount",
            NetSalesExVat = "NetSalesExVat",
            VatOfNetSales = "VatOfNetSales"
        }
    }
}
